import React, { useState } from "react";
import Button from "@mui/material/Button";
import Grid from "@mui/material/Grid2";
import LinearProgress from "@mui/material/LinearProgress";
import Typography from "@mui/material/Typography";
import RefreshIcon from "@mui/icons-material/Refresh";
import AlertDialog from "./confirmDialog";

import { classes, ProgressGrid } from "./style";

export const ProgressBar = ({ progressText, progress, handleRestart }) => {
  const [confirmOpen, setConfirmOpen] = useState(false);
  const onClose = () => setConfirmOpen(false);
  const onConfirm = () => {
    handleRestart();
    setConfirmOpen(false);
  };

  return (
    <>
      <AlertDialog
        title="Restart the quiz?"
        body="Are you sure you want to clear your results and restart the quiz?"
        yes="Restart"
        no="Cancel"
        color="primary"
        open={confirmOpen}
        onClose={onClose}
        onConfirm={onConfirm}
      />
      <ProgressGrid container>
        <Grid size={{ xs: 6, md: 2 }} className={classes.questionColumn}>
          <div className={classes.progressHeader}>{progressText}</div>
        </Grid>
        <Grid
          size={{ xs: 6 }}
          justifyContent="center"
          display={{ xs: "flex", md: "none" }}
          className={`${classes.questionColumn} ${classes.restartButton}`}
          style={{ marginBottom: "10px" }}
        >
          <Button
            variant="contained"
            onClick={(event) => {
              event.preventDefault();
              setConfirmOpen(true);
            }}
          >
            <RefreshIcon sx={{ mr: 1 }} />
            Start Over
          </Button>
        </Grid>
        <Grid
          size={{ xs: 12, md: 7, ml: 8 }}
          justifyContent="center"
          display="flex"
          className={classes.questionColumn}
        >
          <LinearProgress
            variant="determinate"
            value={progress}
            className={classes.progressBar}
          />
          <Typography
            variant="body2"
            style={{
              color: progress > 50 ? "white" : "black",
              fontWeight: "bold",
              position: "absolute",
              alignItems: "center",
              display: "flex",
            }}
          >
            {`${Math.round(progress)}%`}
          </Typography>
        </Grid>
        <Grid
          size={{ md: 3, xl: 2 }}
          justifyContent="center"
          display={{ xs: "none", md: "flex" }}
          className={`${classes.questionColumn} ${classes.restartButton}`}
        >
          <Button
            variant="contained"
            onClick={(event) => {
              event.preventDefault();
              setConfirmOpen(true);
            }}
          >
            <RefreshIcon sx={{ mr: 1 }} />
            Start Over
          </Button>
        </Grid>
      </ProgressGrid>
    </>
  );
};
